import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import $ from 'jquery';
import { reInitScripts } from '../../utils/re-init-scripts';

export const createAjaxPopup = () => ({
    type: 'ajax',
    mainClass: 'mfp-animate-zoom-in',
    callbacks: {
        elementParse(item) {
            if (item.el !== undefined) {
                const { url, type = 'GET', data = {} } = item.el.data();
                this.st.ajax.settings = { url, type, data, dataType: 'html' };
            }
        },
        ajaxContentAdded() {
            this.contentContainer.find('[data-mfp-close]').on('click', () => {
                this.close();
            });

            if (this.contentContainer) {
                disableBodyScroll(this.content[0]);
                livewire.rescan(this.contentContainer[0]);
                reInitScripts(this.contentContainer, true, false);
            }
        },
        close: function () {
            enableBodyScroll(this.content[0]);
            $(document).trigger('mfp-close');
        }
    }
});
